import { useDispatch } from "react-redux";
import {useGetChatsMutation, useUpdateNameMutation} from "../../../Store/Builder/messaging.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import {appendChats, setChats, setNewChats, setPageInfoChats} from "../../../Store/Slice/messagingSlice";
import showToast from "../../Hooks/toast";

const useGetChatsActiveApi = () => {
  const dispatch = useDispatch();
  const [getChats] = useGetChatsMutation();
  const [update] = useUpdateNameMutation();

  const get = (page) => {
    dispatch(setLoader(true));
    getChats(page)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(setPageInfoChats(res))
        if(res.page <= 1) {
          dispatch(setChats(res.data));
        } else {
          dispatch(appendChats(res.data));
        }
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error account", "error");
      });
  };
  const updateName = (data) => {
    dispatch(setLoader(true));
    update(data)
      .unwrap()
      .then(() => {
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error account", "error");
      });
  };
  const search = (data) => {
    dispatch(setLoader(true));
    getChats(data)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(setPageInfoChats(res))
        if(res.page <= 1) {
          dispatch(setChats(res.data));
        } else {
          dispatch(appendChats(res.data));
        }
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error account", "error");
      });
  }

  return {
    get,
    updateName,
    search,
  };
};

export default useGetChatsActiveApi;
